<div class="main-content">
  <div class="main-heading">
    <span>
      <a
        [routerLink]="['../../../archive/list']"
        *ngIf="featureKey == null"
        class="btn btn-icon"
      >
        <span class="icon ic-xs icon-back"></span>
      </a>
      <a
        *ngIf="featureKey != null"
        (click)="goBackPreviousPage()"
        class="btn btn-icon"
      >
        <span class="icon ic-xs icon-back"></span>
      </a>
      <span translate>COMPLETE_MANUAL_CONTROL</span
      ><span> - {{ zoneTitle }}</span>
      <span *ngIf="FoodSafetyManualCompleteChecklist">
        {{ FoodSafetyManualCompleteChecklist.Title }}</span
      >
      <ng-template *ngIf="FoodSafetyManualCompleteChecklist">
        <span *ngIf="featureKey != null"> Manual Control </span>
        <span *ngIf="featureKey == null"> All Zone checklist </span>
      </ng-template>
    </span>
  </div>
  <div class="card">
    <div class="card-body">
      <div class="specialized-checklist">
        <header>
          <strong>{{
            "CHECKLIST_REDESIGN.ANSWERED"
              | translate: { answered: answered, total: checkpoints.length }
          }}</strong>
          <progress
            [value]="answered"
            [max]="checkpoints.length || 1"
          ></progress>
        </header>
        <nav *ngIf="checkpoints.length >= 25" class="specialized-checklist-nav">
          <button
            class="btn btn-outline-secondary"
            *ngFor="let page of checkpointPages"
            (click)="checkpointPage = page"
            [class.active]="checkpointPage === page"
          >
            {{ page * 10 + 1 }}–{{
              MathMin((page + 1) * 10, checkpoints.length)
            }}
          </button>
          <button class="btn btn-outline-secondary" (click)="markRestNa()">
            {{ "CHECKLIST_REDESIGN.MARK_REST_NA" | translate }}
          </button>
        </nav>
        <nav class="specialized-checklist-nav" *ngIf="checkpoints.length >= 25">
          <button
            type="button"
            class="btn btn-outline-secondary"
            [class.active]="checkpointFilter === 'all'"
            (click)="checkpointFilter = 'all'"
          >
            {{ "CHECKLIST_REDESIGN.ALL" | translate }}
          </button>
          <button
            type="button"
            class="btn btn-outline-secondary"
            [class.active]="checkpointFilter === 'unanswered'"
            (click)="checkpointFilter = 'unanswered'"
          >
            {{ "CHECKLIST_REDESIGN.UNANSWERED" | translate }}
          </button>
          <button
            type="button"
            class="btn btn-outline-secondary"
            [class.active]="checkpointFilter === 'deviations'"
            (click)="checkpointFilter = 'deviations'"
          >
            {{ "DEVIATIONS" | translate }}
          </button>
        </nav>
        <button
          type="button"
          class="btn btn-link"
          *ngIf="answered < checkpoints.length"
          (click)="firstUnanswered()"
        >
          {{ "CHECKLIST_REDESIGN.FIRST_UNANSWERED" | translate }}
        </button>
        <article
          *ngFor="let List of visibleCheckpoints; let i = index"
          class="specialized-checkpoint"
        >
          <h3>{{ List.ObjectName }}</h3>
          <p>
            {{ List.TypeOfObject }} · {{ "MIN_TEMP" | translate }}:
            {{ List.MinTemp }} · {{ "MAX_TEMP" | translate }}:
            {{ List.MaxTemp }}
          </p>
          <label
            >{{ "FOOD_SAFETY_TEMPRATURE" | translate
            }}<p-inputnumber
              #temperatureInput
              [showButtons]="true"
              [(ngModel)]="List.Temperature"
              (ngModelChange)="queueDraft()"
              (onKeyDown)="onTemperatureKeyDown($event, temperatureInput)"
              [minFractionDigits]="0"
              [maxFractionDigits]="1"
              [useGrouping]="false"
              [step]="0.1"
              [min]="-80"
              [max]="300"
            ></p-inputnumber
          ></label>
          <div class="specialized-checkpoint-status">
            <button
              type="button"
              *ngFor="let status of List.Status; let statusIndex = index"
              class="btn btn-outline-primary"
              [class.active]="status.Value"
              [attr.aria-pressed]="status.Value"
              (click)="setStatus(status, List.Status)"
            >
              {{
                ["OK", "NOT_APPLICABLE", "DEVIATION"][statusIndex] | translate
              }}
            </button>
          </div>
          <label
            >{{ "COMMENTS" | translate
            }}<textarea
              [(ngModel)]="List.Comments"
              (ngModelChange)="queueDraft()"
              class="form-control"
              rows="2"
            ></textarea>
          </label>
        </article>
        <p role="status">{{ draftStatus | translate }}</p>
      </div>
      <div class="action-btns-wrapper">
        <button
          [routerLink]="['../../../archive/list']"
          *ngIf="featureKey == null && featureId == 20"
          class="btn btn-outline-secondary"
        >
          <span class="icon ic-xs icon-back"></span>
          <span translate>BACK_LIST</span>
        </button>
        <button
          (click)="goBackPreviousPage()"
          *ngIf="featureKey == null && featureId != 20"
          class="btn btn-outline-secondary"
        >
          <i class="pi pi-arrow-left"></i>
          <span translate>BACK_CONTROL</span>
        </button>
        <button
          *ngIf="featureKey != null"
          (click)="goBackPreviousPage()"
          class="btn btn-outline-secondary"
        >
          <i class="pi pi-arrow-left"></i>
          <span *ngIf="featureId != 20" translate>BACK_CONTROL</span>
          <span *ngIf="featureId == 20" translate>BACK_FOODSAFETY</span>
        </button>
        <button
          [disabled]="checkValid() || draftSaving || showLoader"
          (click)="Saveforlater()"
          class="btn btn-primary"
        >
          <span translate>SAVE_FOR_LATER</span>
        </button>
        <button
          [disabled]="checkValid() || draftSaving || showLoader"
          class="btn btn-primary"
          (click)="SaveCompleteCheckList()"
        >
          <span translate>SAVE_AND_COMPLETE</span>
        </button>
      </div>
      <!--Panel Loader-->
      <kuba-busy [busy]="showLoader" message="PROCESSING"></kuba-busy>
      <!--Panel Loader-->
    </div>
  </div>
</div>
<p-confirmDialog
  width="425"
  acceptLabel="{{ 'SWITCH_YES' | translate }}"
  rejectLabel="{{ 'SWITCH_NO' | translate }}"
></p-confirmDialog>
